import { IconFunctionalInformation12, Link } from '@cian/ui-kit';
import { Tooltip } from '@cian/ui-kit/tooltip';

import { normalizeListItems } from 'shared/utils/faq';

import * as styles from './styles.css';

import type { TAnswer } from 'shared/types/faq';

interface IRowProps {
  content: TAnswer;
  onLinkClick?: (link: string) => void;
}

export const Row: React.FC<IRowProps> = ({ content, onLinkClick }) => {
  if (content.type === 'link') {
    return (
      <Link
        href={content.url}
        target="_blank"
        rel="noopener noreferrer"
        inline
        fontSize="S"
        onClick={() => onLinkClick?.(content.url)}
      >
        {content.value}
      </Link>
    );
  }

  if (content.type === 'list') {
    const List = content.style === 'bullet' ? 'ul' : 'ol';
    const items = normalizeListItems(content.value);

    return (
      <List>
        {items.map((item, index) => (
          <li key={index}>
            {item.map((part, partIndex) => (
              <Row key={partIndex} content={part} onLinkClick={onLinkClick} />
            ))}
          </li>
        ))}
      </List>
    );
  }

  if (content.type === 'tooltip') {
    return (
      <Tooltip title={content.value}>
        <span className={styles['tooltip-trigger']}>
          <IconFunctionalInformation12 />
        </span>
      </Tooltip>
    );
  }

  return <span>{content.value}</span>;
};
